module.exports = __webpack_public_path__ + "static/img/5.54812d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/eng/5.png
// module id = NJXI
// module chunks = 0